import { profileRows } from "@/mocks/profile";

export default function DetailSection() {
  return (
    <section id="details" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl mb-10">
          <p className="font-label text-primary-600 text-xs tracking-[0.25em] mb-3">DETAILS / 资料</p>
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950 mb-4">
            个人资料详情表
          </h2>
          <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
            把散落在各处的资料条理化，是本页的主要目的。下表把能整理的项目集中列出，并在存在分歧的地方直接写明，
            避免把不确定的信息包装成结论。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[1fr_360px] gap-6 lg:gap-8">
          <div className="rounded-lg border border-background-200 overflow-hidden bg-background-50">
            <table className="w-full text-left border-collapse">
              <caption className="sr-only">松下纱荣子个人资料整理表</caption>
              <thead>
                <tr className="bg-foreground-950">
                  <th scope="col" className="font-label text-xs text-background-100 px-5 py-3.5 w-36 md:w-44">
                    项目
                  </th>
                  <th scope="col" className="font-label text-xs text-background-100 px-5 py-3.5">
                    整理内容
                  </th>
                </tr>
              </thead>
              <tbody>
                {profileRows.map((row, idx) => (
                  <tr
                    key={row.field}
                    className={idx % 2 === 0 ? "bg-background-50" : "bg-background-100"}
                  >
                    <th
                      scope="row"
                      className="font-label text-sm text-foreground-600 px-5 py-4 align-top text-left font-normal"
                    >
                      {row.field}
                    </th>
                    <td className="text-foreground-900 text-sm md:text-[15px] px-5 py-4 align-top">
                      {row.value}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <aside className="space-y-4">
            <div className="bg-accent-50 border border-accent-200 rounded-lg p-5 md:p-6">
              <h3 className="font-heading font-bold text-accent-900 text-base mb-3 flex items-center gap-2">
                <i className="ri-alert-line" aria-hidden="true"></i>
                阅读提醒
              </h3>
              <p className="text-accent-900/85 text-sm leading-relaxed">
                以上内容由公开信息与网络讨论整理而成，个别条目在不同来源之间说法不一。本站不给出未经确认的数字或结论，
                涉及具体年份、身高、出生信息时，请以权威渠道为准。
              </p>
            </div>

            <div className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6">
              <h3 className="font-heading font-bold text-foreground-950 text-base mb-3 flex items-center gap-2">
                <i className="ri-search-eye-line text-primary-600" aria-hidden="true"></i>
                检索建议
              </h3>
              <ul className="space-y-2.5 text-sm text-foreground-700 leading-relaxed">
                <li className="flex gap-2">
                  <i className="ri-arrow-right-s-line text-primary-500 mt-0.5" aria-hidden="true"></i>
                  <span>用完整姓名检索，减少同音误写干扰。</span>
                </li>
                <li className="flex gap-2">
                  <i className="ri-arrow-right-s-line text-primary-500 mt-0.5" aria-hidden="true"></i>
                  <span>先看是否有原始出处，再看转发量。</span>
                </li>
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}